import { motion } from "framer-motion";
import { Handshake } from "lucide-react";

const partners = [
  {
    name: "Sports Etudes Academy",
    description: "Par Ikigai Education",
    logo: "https://customer-assets.emergentagent.com/job_site-creator-1560/artifacts/nk00808h_image.png"
  },
  {
    name: "INF Clairefontaine",
    description: "Institut National du Football",
    logo: "https://customer-assets.emergentagent.com/job_site-creator-1560/artifacts/6nqheqoh_image.png"
  },
  {
    name: "Eurojump",
    description: "Centre de formation équestre",
    logo: "https://customer-assets.emergentagent.com/job_site-creator-1560/artifacts/p6rgtnfc_image.png"
  },
  {
    name: "C.R.E. Montessori",
    description: "Centre de rencontres enfantines",
    logo: "https://customer-assets.emergentagent.com/job_site-creator-1560/artifacts/cde678ip_image.png"
  }
];

export const Partners = () => {
  return (
    <section
      id="partenaires"
      data-testid="partners-section"
      className="py-12 md:py-16 bg-white relative overflow-hidden"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10"
        >
          <div className="inline-flex items-center gap-2 bg-blue-50 rounded-full px-4 py-2 mb-4">
            <Handshake className="w-5 h-5 text-blue-600" />
            <span className="text-blue-600 font-semibold">Ils nous font confiance</span>
          </div>
        </motion.div>

        <div className="grid grid-cols-2 sm:flex sm:flex-wrap items-center justify-center gap-6 sm:gap-8 md:gap-12 max-w-6xl mx-auto">
          {partners.map((partner, index) => (
            <motion.div
              key={partner.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              data-testid={`partner-card-${index}`}
              className="group text-center"
            >
              <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 bg-gray-50 rounded-2xl flex items-center justify-center mx-auto mb-3 p-3 group-hover:shadow-lg group-hover:scale-105 transition-all duration-300 border border-gray-100">
                {partner.logo ? (
                  <img src={partner.logo} alt={partner.name} loading="lazy" className="w-full h-full object-contain" />
                ) : (
                  <span className="text-3xl font-bold text-blue-600">
                    {partner.name.charAt(0)}
                  </span>
                )}
              </div>
              <h3 className="text-gray-800 font-semibold text-sm">{partner.name}</h3>
              <p className="text-gray-500 text-xs">{partner.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
